<template>
	<el-drawer
		:visible="true"
		@close="close"
		style="border-radius: 0 25px 0 25px; z-index: 100"
		direction="rtl"
		:with-header="false"
		size="80%"
	>
		<div v-if="variable" class="drawer-header">
			<div style="margin-top: auto; margin-bottom: auto; margin-left: 10px">
				<span class="title" style="margin-left: 5px">{{ item.name }}</span>
			</div>
			<div style="margin-left: auto; margin-right: 0; margin-top: auto; margin-bottom: auto">
				<md-button class="md-icon-button" @click="close">
					<md-icon style="color: white">close</md-icon>
				</md-button>
			</div>
		</div>
		<div v-if="variable" class="drawer-body">
			<div class="container-tab">
				<div :class="{ 'tab-effect': tab != 0 }" class="tab" @click="tab = 0">
					<span :class="{ 'tab-selected': tab == 0 }">{{ $t("details") }}</span>
				</div>
			</div>

			<div v-if="tab == 0" :style="{ height: height - 75 + 'px' }" style="padding: 10px; overflow-y: auto">
				<div style="display:flex">
					<div style="flex:1; padding-left: 15px;">
						<h1>{{ item.name }}</h1>
					</div>
					<div style="display:flex; justify-content: flex-end; align-items:center; width: 25%"
						 v-if="tab == 0">
						<option-button
							:show="true"
							:buttons="buttons"
							:saving="saving"
							@save="handleSave"
							@clear="close"
							@block="value => handleBlock(value)"
						/>
					</div>
				</div>
				<variables-form :variable="variable" :editable="true" :source="'edit'" @change="edit = true" />
			</div>

		</div>
	</el-drawer>
</template>
<script>
/*eslint-disable*/
import axios from "axios"
import { mapGetters, mapActions } from "vuex"
import OptionButton from "@/modules/_common/button/option-button.vue"
import VariablesForm from "@/modules/datas/variables/variables-components/variables-form.vue"

export default {
	name: "variables-details",
	components: {
		OptionButton,
		VariablesForm
	},
	data() {
		return {
			height: window.innerHeight - 100,
			tab: 0,
			variable: undefined,
			edit: false,
			saving: false
		}
	},
	computed: {
		...mapGetters({
			item: "variable/variable"
		}),
		buttons: function() {
			if (this.edit) return ["save", "clear"]
			return []
		}
	},
	async mounted() {
		if (this.item == undefined && this.$route.params.id) {
			await this.getVariableById(this.$route.params.id)
		}
		this.set()
	},

	methods: {
		...mapActions({
			getVariableById: "variable/doGetById",
			doMutate: "variable/doMutate"
		}),
		close: function() {
			this.$router.push({ path: "/datas/variables" })
		},

		set: function() {
			this.variable = { ...this.item }
			this.variable.rules = { ...this.item.rules }
			if (this.item.rules.computed_rules && this.item.rules.computed_bool) this.variable.rules.computed_rules = [...this.item.rules.computed_rules]
		},

		handleSave: function() {
			var payload = { ...this.variable }
			this.saving = true

			var filtered_rules = {}
			for (const [key, value] of Object.entries(payload.rules)) {
				if (value != undefined && value !== "")
					if (
						!Array.isArray(value) ||
						(Array.isArray(value) && value.length) ||
						(Array.isArray(value) && value.length == 1 && Array.isArray(value[0]) && value[0].length)
					) {
						//toglie le stringhe vuote
						//toglie gli array vuoti (list: []), e gli array con un elemento array vuoto (computed_rules: [[]])
						if (key !== "default" || (key == "default" && payload.rules.readonly))
							filtered_rules[key] = value
					}
			}
			payload.rules = JSON.stringify(filtered_rules)
			this.variable.rules = filtered_rules

			axios
				.post(process.env.VUE_APP_API_URL + "/api/customfields/update", payload, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					this.$notification("success", this.$t("save-successful"), "", 5000)
					this.saving = false
					this.edit = false
					this.doMutate({ element: "variable", value: this.variable })
				})
				.catch(err => {
					console.error(err)
					this.saving = false
					this.$notification("error", this.$t("save-error"), "", 0)
				})
		},

		handleBlock: function(value) {
			var payload = {
				id: this.variable.id,
				visible: value
			}
			axios
				.post(process.env.VUE_APP_API_URL + "/api/customfields/update", payload, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					if (res.data) {
						this.item = {
							...this.item,
							visible: value
						}
						this.$notification({
							title: value ? this.$t("sblocking-variable") : this.$t("blocking-variable"),
							type: res.data ? "success" : "error",
							duration: res.data ? 5000 : 0,
							message:
								("i", { style: "color: teal" }, res.data ? this.$t("successfully") : this.$t("errors"))
						})
					}
				})
				.catch(err => console.error(err))
		}
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/my-tab.scss";
@import "src/assets/scss/my-form";
@import "src/assets/scss/my-drawer";
</style>
